import { render, staticRenderFns } from "./FooterAttribution.vue?vue&type=template&id=1f338520&"
import script from "./FooterAttribution.vue?vue&type=script&lang=js&"
export * from "./FooterAttribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports